import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_PRO || '')

export default function MuiXLicense() {
  return null;
}
